import assert from 'assert';
import { includes, get } from 'lodash-es';

export const payarcSdkSourceName = 'PAYARC_JS_SDK';
export const payarcFormSourceName = 'PAYARC_PAYMENT_FORM';
export const payarcPaymentPageName = 'PAYARC_PAYMENT_PAGE';

export const sendingMessagesNames = [
  'INITED',
  'LOADED',
  'FORM_RESIZE',
  'PAYMENT_FAILED_TO_BEGIN',
  'PAYMENT_NEW',
  'PAYMENT_BEFORE_CREATED',
  'PAYMENT_CREATED',
  'PAYMENT_FAILED_TO_CREATE',
  'PAYMENT_COMPLETED',
  'PAYMENT_CANCELLED',
  'PAYMENT_DECLINED',
  'PAYMENT_INTERRUPTED',
  'PAYMENT_SYSTEM_SUCCESS',
  'PAYMENT_RECREATE_TO_BEGIN',
  'PAYMENT_RECREATE_TO_CONTINUE',
  'MODAL_CLOSED',
];

export const receivingMessagesNames = [
  'REQUEST_INIT_FORM',
  'PAYMENT_RESULT_PAGE_REPORT',
];

export function postMessage(name, data = {}) {
  assert(includes(sendingMessagesNames, name), `Undefiend postMessage name: ${name}`);
  const target = window.opener ? window.opener : window.parent;
  target.postMessage({
    source: payarcFormSourceName,
    name,
    data,
  }, '*');
}

export function receiveMessages(from, objectWithCallbacks) {
  from.addEventListener('message', (event) => {
    const source = get(event, 'data.source');
    if (
      !includes([payarcSdkSourceName, payarcFormSourceName, payarcPaymentPageName], source)
    ) {
      return;
    }
    const { name } = event.data;
    if (!includes(receivingMessagesNames, name)) {
      return;
    }
    const callback = objectWithCallbacks[name];
    if (!callback) {
      return;
    }
    callback(event.data.data);
  });
}
